// ==============================|| DASHBOARD - MARKET SHARE AREA CHART ||============================== //
import { Props } from 'react-apexcharts';

const chartData: Props = {
    height: 300,
    type: 'area',
    options: {
        chart: {
            id: 'market-share-area-chart',
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    pan: true,
                    reset: false
                }
            },
            zoom: {
                enabled: true
            },
            sparkline: {
                enabled: false
            }
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            curve: 'smooth',
            width: 2
        },
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 80, 100]
            }
        },
        legend: {
            show: false
        },
        yaxis: {
            labels: {
                show: false
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                show: true,
                style: {
                    colors: '#fff'
                }
            }
        },
        grid: {
            yaxis: {
                lines: {
                    show: false
                }
            }
        }
    },
    series: []
};

export default chartData;
